import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = {
  key: 1,
  class: "h-full w-full flex items-center justify-center px-8"
}
const _hoisted_5 = {
  key: 2,
  class: "h-full w-full flex items-center justify-center flex-col gap-2"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Your inspection images have been archived.")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("To view your images, assemblies, and reports again, please click the button below to re-import the data.")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Note: The re-import process may take some time depending on the data volume.")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Re-import Data")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ALL IMAGES FOR THIS TURBINE WILL BE RE-IMPORTED")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("THIS MAY TAKE TIME")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("START")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("CANCEL")

import {
  computed,
  onBeforeUnmount,
  onMounted,
  provide,
  ref, watch,
  PropType,
  Ref,
  inject, ComputedRef,
} from 'vue';
import OpenSeadragon from 'openseadragon';

import { useQueryClient } from 'vue-query';
import { useRoute, useRouter } from 'vue-router';

import { useGetDeviceQuery } from '@/entities/device/hooks';
import { useGetInspectionQuery } from '@/entities/inspection/hooks';

import { TargetAnnotation } from '@/teams/visionair/components/AnnotationWorkspace.vue';
import { Inspection } from '@/entities/inspection/types';
import { Annotation } from '@/entities/annotation/types';
import { Device } from '@/entities/device/types';
import {
  CompleteLocation,
  OSDExposition,
  OverlayEventMap,
} from '@/core/components/data-display/OSD/osd.shared';

import {
  NkButton,
  NkGroup,
  NkOSD,
  NkIcon,
  NkHeading,
  NkStack,
  NkOSDOverlayMeasure,
  NkText,
  NkInlineModal
} from '@/core/components';

import InspectionHistoryViewer
  from '@/teams/visionair/components/InspectionViewer/InspectionHistoryViewer.vue';
import InspectionViewerAnnotation
  from '@/teams/visionair/components/InspectionViewer/InspectionViewerAnnotation.vue';
import NkOSDOverlayCreator from '@/core/components/data-display/OSD/NkOSDOverlayCreator.vue';
import { StOSDOverlayBackground } from '@/core/components/data-display/OSD/osd.styled';
import InspectionViewerAnnotationFormGroup
  from '@/teams/visionair/components/InspectionViewer/InspectionViewerCreateAnnotationFormGroup.vue';
import InspectionViewerUpdateAnnotationForm
  from '@/teams/visionair/components/InspectionViewer/InspectionViewerUpdateAnnotationForm.vue';
import InspectionLinkViewer
  from '@/teams/visionair/components/InspectionViewer/InspectionLinkViewer.vue';

import { annotationsQueryName, useGetAnnotationQuery } from '@/entities/annotation/hooks';
import { api, getDomainPath } from '@/services';

import {
  events,
  InspectionViewerInjection,
  inspectionViewerInjectionKey,
  SetActiveAnnotationParams,
} from '@/teams/visionair/components/InspectionViewer/inspection-viewer.shared';
import {useGetInspectionGroupQuery} from "@/entities/inspection-group/hooks";
import store from "@/store";
import InspectionViewerUpdateAnnotationFormSherlock
  from '@/teams/visionair/components/InspectionViewer/InspectionViewerUpdateAnnotationFormSherlock.vue';
import axios from 'axios';
import { ElNotification } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionViewer',
  props: {
  inspection: {
    type: Number as PropType<Inspection['id']>,
    required: true,
  },
  targetAnnotation: {
    type: Object as TargetAnnotation,
    default: null,
  },
},
  emits: ['reset-target-annotation'],
  setup(__props, { emit }) {

const props = __props





const router = useRouter();
const route = useRoute();
const queryClient = useQueryClient();

const osd = ref<OSDExposition | undefined>();

const {isFullscreen} = inject<any>('injectedWorkspace');

const targetedAnnotation = computed(() => route.query.annotation);

const inspectionQueryData = computed(() => ({ id: props.inspection }));
const hasInspectionQueryData = computed(() => !!inspectionQueryData.value.id);
const {
  data: inspection,
  refetch: refetchInspection,
  isRefetching: isInspectionRefetching,
  isLoading: inspectionLoading,
} = useGetInspectionQuery(inspectionQueryData, {
  refetchOnWindowFocus: false,
  enabled: hasInspectionQueryData,
});

const ReImportModal = ref()
const sendAndCloseModal = async () => {
  await api.get(`/inspections/${inspection.value.id ?? ''}/re-import`)
  ElNotification({
    type: 'success',
    position: 'bottom-right',
    title: 'Request submited',
    message: 'Your request just got submited to Supairvision team'
  })
  ReImportModal.value?.closeDialog()
}
const closeModal = () => {
  ReImportModal.value?.closeDialog()
}

const inspectionGroupQueryData = computed(() => ({ id: inspection.value?.inspectionGroup }));
const hasInspectionGroupQueryData = computed(() => !!inspectionGroupQueryData.value.id);
const { data: inspectionGroup } = useGetInspectionGroupQuery(inspectionGroupQueryData, {
  enabled: hasInspectionGroupQueryData,
});

store.dispatch('service/setService', inspectionGroup.value?.service);

const deviceQueryData = computed(() => ({ id: inspection.value?.device }));
const hasDeviceData = computed(() => !!deviceQueryData.value.id);
const { data: device } = useGetDeviceQuery(deviceQueryData, { enabled: hasDeviceData });

const isLastDeviceInspection = computed(() => inspection.value?.isLastInspection);

const dziPath = computed(() => getDomainPath(inspection.value?.dziPath));

// Controls
const isCreatingAnnotation = ref(false);
const isLinkingAnnotation = ref(false);
const isMeasuring = ref(false);
const newAnnotationLocation = ref<CompleteLocation | null>(null);

const historyVisible = ref(false);
const isSplitting = computed(() => historyVisible.value || isLinkingAnnotation.value);

// Annotations
const selectedAnnotation = ref<Annotation['id'] | null>();
const hoveredAnnotation = ref<Annotation['id'] | null>(null);
const activeAnnotation = ref<{ id: Annotation['id']; location: Parameters<OverlayEventMap['click']>[0]['location'] } | null>(null);
const choosenAnnotation = computed(() => activeAnnotation.value?.id || selectedAnnotation.value || null);
const imageHeight: Ref = computed(() => {
  if (osd.value?.getViewer().world.getItemAt(0)) {
    return osd.value?.getViewer().world.getItemAt(0).getContentSize()
  }

  return {x: 0, y :0}
});

const onOverlayCreate = (completeLocation: CompleteLocation) => {
  router.replace({ query: { view: route.query.view || '' } });
  activeAnnotation.value = null;
  newAnnotationLocation.value = completeLocation;
  isCreatingAnnotation.value = false;
};

const onAnnotationClick = (annotationId: Annotation['id'], event: Parameters<OverlayEventMap['click']>[0]) => {
  router.replace({ query: { view: route.query.view || '' } });
  selectedAnnotation.value = null;

  if (isCreatingAnnotation.value) {
    return;
  }
  if (newAnnotationLocation.value) {
    events.emit('annotation-click', {
      inspection: (inspection.value?.id as Inspection['id']),
      device: (inspection.value?.device as Device['id']),
      annotation: annotationId,
    });
  } else {
    activeAnnotation.value = {
      id: annotationId,
      location: event.location,
    };
  }
};

const handleAnnotationSelect = (id: Annotation['id']) => {
  activeAnnotation.value = null;
  selectedAnnotation.value = id;
};

const isAnnotationActive = (annotationId: Annotation['id']) =>
  !isCreatingAnnotation.value &&
  [hoveredAnnotation.value, selectedAnnotation.value, activeAnnotation.value?.id].filter(Boolean).includes(annotationId);

const onAnnotationFocus = (annotationId: Annotation['id']) => {
  hoveredAnnotation.value = annotationId;
};
const onAnnotationBlur = () => {
  hoveredAnnotation.value = null;
};

// OSD
const centerFormView = (location: OpenSeadragon.Rect) => {
  const viewer = osd.value?.getViewer();
  if (viewer) {
    const point = viewer.viewport.getBounds();
    viewer.viewport.panTo(new OpenSeadragon.Rect(location.x + point.width / 4, location.y, location.width, location.height).getCenter(), false);
  }
};

const setActiveAnnotation = ({ id, location }: SetActiveAnnotationParams) => {
  activeAnnotation.value = {
    id,
    location,
  };
  centerFormView(location);
};

const setHoveredAnnotation = (id: Annotation['id'] | null = null) => {
  hoveredAnnotation.value = id;
};

const watchKeyDownEvent = (e: KeyboardEvent) => {
  if (e.key === 'Escape' && (isCreatingAnnotation.value || newAnnotationLocation.value || activeAnnotation.value)) {
    isCreatingAnnotation.value = false;
    newAnnotationLocation.value = null;
    activeAnnotation.value = null;
  }
};

watch(() => props.targetAnnotation, (value) => {
  if (!value) {
    activeAnnotation.value = null;
    hoveredAnnotation.value = null;
  }

  if (value?.type === 'click') {
    const annotationState: Annotation|undefined = queryClient.getQueryCache()?.find([annotationsQueryName, { id: value.id }])?.state.data;

    if (annotationState && annotationState.position) {
      setActiveAnnotation({
        id: value.id,
        location: new OpenSeadragon.Rect(
          annotationState.position.viewportX,
          annotationState.position.viewportY,
          annotationState.position.viewportWidth,
          annotationState.position.viewportHeight,
        ),
      });
    } else {
      activeAnnotation.value = null;
    }
  }

  if (value?.type === 'hover') {
    hoveredAnnotation.value = value.id;
  }
});

const annotationQueryData = computed(() => ({ id: targetedAnnotation.value }));
const hasAnnotationQueryData = computed(() => !!annotationQueryData.value.id);
const { data: targetAnnotation } = useGetAnnotationQuery(annotationQueryData, { enabled: hasAnnotationQueryData });
const position: ComputedRef<Annotation['position'] | undefined> = computed(() => targetAnnotation.value?.position);

const rect = ref();

const annotationFitViewport = () => {
  if (rect.value) {
    const viewer = osd.value?.getViewer();
    viewer?.viewport.fitBoundsWithConstraints(rect.value);
  }
}

const centerOnAnnotation = () => {
  if (position.value) {
    rect.value = new OpenSeadragon.Rect(position.value.viewportX, position.value.viewportY, position.value.viewportWidth, position.value.viewportHeight);

    const viewer = osd.value?.getViewer();
    viewer?.viewport.fitBoundsWithConstraints(rect.value);

    if (route.query.showMenu === 'open') {
      /** The only way to zoom correctly to the corresponding annotation */
      viewer?.viewport.zoomTo(1);
      setActiveAnnotation({
        id: Number(route.query.annotation),
        location: rect.value
      });
    } else if (activeAnnotation.value !== null && route.query.showMenu !== 'open') {
      activeAnnotation.value = null
    }

    // Remove query to avoid zooming by switching view
    router.replace({ query: { view: 2 } });
  }

}

const missingDziRender = ref(false)

watch(targetAnnotation, centerOnAnnotation);

watch(inspection, async () => {
  if (inspection.value) {
    try {
    await axios.get(`${process.env.VUE_APP_BACKEND_URL}/${inspection.value?.dziPath ?? ''}`)
    } catch {
      missingDziRender.value = true
    }
  }
}, {immediate: true})

onMounted(() => {
  document.addEventListener('keydown', watchKeyDownEvent);

  centerOnAnnotation();
  const viewer = osd.value?.getViewer();
  viewer?.addHandler('open', annotationFitViewport);
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', watchKeyDownEvent);

  const viewer = osd.value?.getViewer();
  viewer?.removeHandler('open', annotationFitViewport);
});

// Rest
provide<InspectionViewerInjection>(inspectionViewerInjectionKey, {
  hoveredAnnotation,
  centerFormView,
  setActiveAnnotation,
  setHoveredAnnotation,
  imageHeight
});

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex", {
      'cursor-crosshair': isCreatingAnnotation.value,
    }])
  }, [
    (_unref(inspection))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: _normalizeClass(["h-full", {
          'w-full': !_unref(isSplitting),
          'w-[50%]': _unref(isSplitting)
        }])
          }, [
            (_unref(inspection).dziProcessDone && _unref(inspection).dziPath && !missingDziRender.value)
              ? (_openBlock(), _createBlock(_unref(NkOSD), {
                  key: _unref(isSplitting),
                  ref_key: "osd",
                  ref: osd,
                  options: {
            tileSources: _unref(dziPath),
            showNavigator: !_unref(isSplitting),
            navigatorPosition: 'ABSOLUTE',
            navigatorLeft: '100%',
            navigatorHeight: '100%',
            navigatorWidth: '100px',
          }
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(inspection).annotationDetails, (annotation) => {
                      return (_openBlock(), _createBlock(InspectionViewerAnnotation, {
                        key: annotation.id,
                        active: isAnnotationActive(annotation.id),
                        annotation: annotation.id,
                        class: _normalizeClass([isCreatingAnnotation.value ? 'pointer-events-none' : 'cursor-pointer']),
                        title: `Annotation ${annotation.id}, Hub distance: ${annotation.distanceFromHub}, Defect Size: ${annotation.defectSize}`,
                        highlight: isAnnotationActive(annotation.id),
                        onClick: ($event: any) => (onAnnotationClick(annotation.id, $event)),
                        onFocusin: _cache[1] || (_cache[1] = () => {}),
                        onFocusout: _cache[2] || (_cache[2] = () => {}),
                        onMouseenter: () => onAnnotationFocus(annotation.id),
                        onMouseleave: _cache[3] || (_cache[3] = () => onAnnotationBlur())
                      }, {
                        "context-menu": _withCtx(() => [
                          (_unref(isSplitting) && !activeAnnotation.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (selectedAnnotation.value !== annotation.id)
                                  ? (_openBlock(), _createElementBlock("li", {
                                      key: 0,
                                      class: "flex items-center gap-2",
                                      onClick: ($event: any) => (handleAnnotationSelect(annotation.id))
                                    }, [
                                      _createVNode(_unref(NkIcon), { name: "NkCheckCircle" }),
                                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('inspection.viewer.actions.select')), 1)
                                    ], 8, _hoisted_1))
                                  : (_openBlock(), _createElementBlock("li", {
                                      key: 1,
                                      class: "flex items-center gap-2",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedAnnotation.value = null))
                                    }, [
                                      _createVNode(_unref(NkIcon), { name: "NkClose" }),
                                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('inspection.viewer.actions.un_select')), 1)
                                    ]))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["active", "annotation", "class", "title", "highlight", "onClick", "onMouseenter"]))
                    }), 128)),
                    (isCreatingAnnotation.value)
                      ? (_openBlock(), _createBlock(NkOSDOverlayCreator, {
                          key: 0,
                          onCreate: onOverlayCreate
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(StOSDOverlayBackground), {
                              class: "w-full h-full",
                              service: _ctx.$store.getters['service/service']
                            }, null, 8, ["service"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (activeAnnotation.value && ![3,4,7].includes(_unref(inspectionGroup).service))
                      ? (_openBlock(), _createBlock(InspectionViewerUpdateAnnotationForm, {
                          key: activeAnnotation.value.id,
                          inspection: _unref(inspection).id,
                          device: _unref(inspection).device,
                          annotation: activeAnnotation.value.id,
                          "inspection-group": _unref(inspection).inspectionGroup,
                          location: activeAnnotation.value.location,
                          splitted: _unref(isSplitting),
                          onCancel: _cache[4] || (_cache[4] = () => {
                _unref(refetchInspection)();
                activeAnnotation.value = null
                _ctx.$emit('cancel');
              }),
                          onSubmitted: _cache[5] || (_cache[5] = ($event: any) => (activeAnnotation.value = null))
                        }, null, 8, ["inspection", "device", "annotation", "inspection-group", "location", "splitted"]))
                      : (activeAnnotation.value)
                        ? (_openBlock(), _createBlock(InspectionViewerUpdateAnnotationFormSherlock, {
                            key: activeAnnotation.value.id,
                            inspection: _unref(inspection).id,
                            device: _unref(inspection).device,
                            annotation: activeAnnotation.value.id,
                            "inspection-group": _unref(inspection).inspectionGroup,
                            location: activeAnnotation.value.location,
                            splitted: _unref(isSplitting),
                            onCancel: _cache[6] || (_cache[6] = () => {
                _unref(refetchInspection)();
                activeAnnotation.value = null
                _ctx.$emit('cancel');
              }),
                            onSubmitted: _cache[7] || (_cache[7] = ($event: any) => (activeAnnotation.value = null))
                          }, null, 8, ["inspection", "device", "annotation", "inspection-group", "location", "splitted"]))
                        : _createCommentVNode("", true),
                    (!!newAnnotationLocation.value)
                      ? (_openBlock(), _createBlock(InspectionViewerAnnotationFormGroup, {
                          key: 3,
                          completeLocation: newAnnotationLocation.value,
                          device: _unref(inspection).device,
                          inspection: _unref(inspection).id,
                          "inspection-group": _unref(inspection).inspectionGroup,
                          onCancel: _cache[8] || (_cache[8] = () => {
                newAnnotationLocation.value = null
              }),
                          onSubmitted: _cache[9] || (_cache[9] = () => {
                newAnnotationLocation.value = null
              })
                        }, null, 8, ["completeLocation", "device", "inspection", "inspection-group"]))
                      : _createCommentVNode("", true),
                    (isMeasuring.value)
                      ? (_openBlock(), _createBlock(_unref(NkOSDOverlayMeasure), {
                          key: 4,
                          inspection: props.inspection
                        }, null, 8, ["inspection"]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(NkGroup), {
                      spacing: 4,
                      class: "absolute bottom-[60px] right-[60px] bg-white bg-opacity-80 p-2 rounded-full"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.$store.getters['connection/isGranted'](['annotation_create']))
                          ? (_openBlock(), _createBlock(_unref(NkButton), {
                              key: 0,
                              disabled: !!newAnnotationLocation.value || !_unref(isLastDeviceInspection) || _unref(isSplitting),
                              title: !_unref(isLastDeviceInspection) ? _ctx.$t('inspection.viewer.messages.not_last_inspection') : '',
                              type: isCreatingAnnotation.value ? 'primary' : 'white',
                              circle: "",
                              icon: "NkComment",
                              onClick: _cache[10] || (_cache[10] = () => {
                isCreatingAnnotation.value = !isCreatingAnnotation.value;
                isMeasuring.value = false;
              })
                            }, null, 8, ["disabled", "title", "type"]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(NkButton), {
                          circle: "",
                          icon: "NkSmallRuler",
                          type: isMeasuring.value ? 'primary' : 'white',
                          onClick: _cache[11] || (_cache[11] = () => {
                isCreatingAnnotation.value = false;
                isMeasuring.value = !isMeasuring.value;
                newAnnotationLocation.value = null;
                historyVisible.value = false;
              })
                        }, null, 8, ["type"]),
                        _createVNode(_unref(NkButton), {
                          type: isLinkingAnnotation.value ? 'success' : 'white',
                          circle: "",
                          icon: "NkCompareArrows",
                          title: _ctx.$t('inspection.viewer.actions.show_relation_layer'),
                          onClick: _cache[12] || (_cache[12] = () => {
                isCreatingAnnotation.value = false;
                newAnnotationLocation.value = null;
                isLinkingAnnotation.value = !isLinkingAnnotation.value;
                historyVisible.value = false;
              })
                        }, null, 8, ["type", "title"]),
                        _createVNode(_unref(NkButton), {
                          type: historyVisible.value ? 'success' : 'white',
                          circle: "",
                          icon: "NkWatchLater",
                          title: _ctx.$t('inspection.viewer.actions.show_history_layer'),
                          onClick: _cache[13] || (_cache[13] = () => {
                isCreatingAnnotation.value = false;
                newAnnotationLocation.value = null;
                historyVisible.value = !historyVisible.value;
                isLinkingAnnotation.value = false;
              })
                        }, null, 8, ["type", "title"]),
                        _createVNode(_unref(NkButton), {
                          icon:  _unref(isFullscreen) ? 'NkCloseFullscreen' : 'NkOpenInFull',
                          type: 'white',
                          circle: "",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (isFullscreen.value = !_unref(isFullscreen)))
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["options"]))
              : (!_unref(inspection)?.dziProcessDone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (!_unref(inspection)?.dziPath)
                      ? (_openBlock(), _createBlock(_unref(NkHeading), {
                          key: 0,
                          type: "italic"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('inspection.viewer.messages.dzi_missing')), 1)
                          ]),
                          _: 1
                        }))
                      : (_unref(inspection)?.dziProgress === 'Missing image')
                        ? (_openBlock(), _createBlock(_unref(NkHeading), {
                            key: 1,
                            type: "italic"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('inspection.viewer.messages.missing_image')), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_unref(NkStack), {
                            key: 2,
                            spacing: 4
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NkHeading), { type: "italic" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('inspection.viewer.messages.slicing_in_progress')), 1)
                                ]),
                                _: 1
                              }),
                              _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
                                disabled: _unref(inspectionLoading),
                                type: "white",
                                onClick: _unref(refetchInspection)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('actions.refresh')), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])), [
                                [_directive_loading, _unref(inspectionLoading) || _unref(isInspectionRefetching)]
                              ])
                            ]),
                            _: 1
                          }))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_unref(NkStack), { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NkText), { class: "!italic !text-lg !text-orange-500" }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NkText), { class: "!italic !text-base !text-white" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NkText), { class: "!italic !text-xs !text-white" }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NkInlineModal), {
                          ref_key: "ReImportModal",
                          ref: ReImportModal
                        }, {
                          content: _withCtx(() => [
                            _createVNode(_unref(NkStack), { align: "center" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NkText), { class: "!italic !font-bold !text-lg" }, {
                                  default: _withCtx(() => [
                                    _hoisted_10
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(NkText), { class: "!italic !font-bold !text-lg !text-orange-500" }, {
                                  default: _withCtx(() => [
                                    _hoisted_11
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(NkGroup), { align: "stretch" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NkButton), {
                                      type: "success",
                                      onClick: sendAndCloseModal
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_12
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(NkButton), {
                                      type: "danger",
                                      onClick: closeModal
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_13
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(NkButton), { icon: "NkDownload" }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    })
                  ]))
          ], 2),
          (isLinkingAnnotation.value && _unref(inspection)?.inspectionGroup)
            ? (_openBlock(), _createBlock(InspectionLinkViewer, {
                key: 0,
                "inspection-group": _unref(inspection)?.inspectionGroup,
                device: _unref(inspection)?.device,
                annotation: _unref(choosenAnnotation),
                class: "w-[50%] relative",
                onClose: _cache[15] || (_cache[15] = () => {
          isLinkingAnnotation.value = false;
          selectedAnnotation.value = null;
        })
              }, null, 8, ["inspection-group", "device", "annotation"]))
            : _createCommentVNode("", true),
          (historyVisible.value)
            ? (_openBlock(), _createBlock(InspectionHistoryViewer, {
                key: 1,
                "inspection-group": _unref(inspection)?.inspectionGroup,
                inspection: props.inspection,
                device: _unref(inspection)?.device,
                annotation: _unref(choosenAnnotation),
                class: "w-[50%] relative",
                onClose: _cache[16] || (_cache[16] = () => {
          historyVisible.value = false;
          selectedAnnotation.value = null;
        })
              }, null, 8, ["inspection-group", "inspection", "device", "annotation"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}
}

})